module.exports = __webpack_public_path__ + "img/t_systems.807a6de3.webp";